import { PerkTypes, Perks, PerkCategories, Scaling } from 'types/perks';

const formatPerk = (
  perkKey: PerkTypes,
  standardResearch: number,
  tradeoffResearch: number,
) => {
  const perk = Perks[perkKey];
  const { category, debuff, scaling } = perk;
  let { value } = perk;
  if (category === PerkCategories.TRADEOFF && scaling !== Scaling.NONE)
    value *= 1 + tradeoffResearch / 100;
  if (category === PerkCategories.STANDARD && scaling !== Scaling.NONE)
    value *= 1 + standardResearch / 100;
  return perk.text
    .replaceAll('{{value}}', value.toFixed(2))
    .replaceAll('{{debuff}}', debuff.toFixed(2));
};

export default formatPerk;
